import { api } from '@/common/api';
import qs from 'qs';

const store = {
    namespaced: true,
    state() {
        return {
            registryEmployers: [],
            pages: {},
            current: {}
        };
    },

    mutations: {
        setRegistryEmployers(state, data) {
            state.registryEmployers = data;
        },
        setPages(state, data) {
            state.pages = data;
        },
        setCurrent(state, data) {
            state.current = data;
        },
        clearStore(state) {
            state.registryEmployers = {};
            state.current = {};
            state.pages = {};
        }
    },
    actions: {
        loadList({ state, commit }) {
            return new Promise((resolve, reject) => {
                api.get('/expenses/registry_employers/').then(response => {
                    commit('setRegistryEmployers', response.data.data.registryEmployers);
                    resolve(response);
                }).catch(
                    error => {
                        reject(error);
                    });
            });
        },
        getPaginatedList({ state, commit }, params) {
            return new Promise((resolve, reject) => {
                api.get('/expenses/registry_employers/?' + qs.stringify(params)).then(response => {
                    commit('setRegistryEmployers', response.data.data);
                    commit('setPages', response.data.meta);
                    resolve(response);
                }).catch(
                    error => {
                        reject(error);
                    });
            });
        }
    },
    getters: {}

};

export default store;
